<template>
  <my-dropdown class="select" @on-click="(index) => tabChange(index)">
    <div class="select-value">
      <input
        type="text"
        class="select-value-ipt"
        :value="carName"
        :placeholder="placeholder"
        readonly
      />
      <svg-icon name="ChevronRight"></svg-icon>
    </div>

    <my-dropdown-menu style="width: 99%">
      <my-dropdown-item
        v-for="(item, index) in carList"
        :key="index"
        :name="index"
      >
        <div class="boxitem">
          <span>{{ item.label }}</span>
          <svg-icon
            v-if="value == item.value"
            name="Checkmark"
            class="boxitem-icon"
          ></svg-icon>
        </div>
      </my-dropdown-item>
    </my-dropdown-menu>
  </my-dropdown>
</template>

<script>
import MyDropdown from "@components/Dropdown/MyDropdown.vue";
import MyDropdownMenu from "@components/Dropdown/MyDropdownMenu.vue";
import MyDropdownItem from "@components/Dropdown/MyDropdownItem.vue";
import SvgIcon from "@components/Icon/index.vue";
export default {
  name: "CarSeriesSelect",
  components: {
    MyDropdown,
    MyDropdownMenu,
    MyDropdownItem,
    SvgIcon,
  },
  props: {
    placeholder: {
      default: "请选择试驾车型",
    },
    value: {
      type: [Number, String],
    },
    carList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      carName: "",
      carData: {},
    };
  },
  watch: {
    value: {
      handler: function(val) {
        const obj = this.carList.find((c) => c.value == val) || this.carList[0];
        this.carName = obj.label;
      },
      immediate: true,
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    hiden() {
      this.visible = false;
    },
    tabChange(index) {
      const item = this.carList[index];
      this.carName = item.label;
      this.carData = {
        ...item,
      };
      this.hiden();
      this.$emit("input", this.carData.value);
      this.$emit("change", this.carData);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@style/base/mixins/media";
@import "@style/base/mixins/scrollBar";
@import "@style/base/variables";
.select {
  width: 100%;
  position: relative;
  .select-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    cursor: pointer;
    .select-value-ipt {
      border: none;
      outline: none;
      height: 100%;
      width: 100%;
      font-size: inherit;
      background: none;
      cursor: pointer;
      &::placeholder {
        color: #ccc;
      }
    }
  }
}
.boxitem {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 22px;
  line-height: 36px;
  @include media(
    (
      $md: (
        font-size: 16px,
        line-height: 26px,
      ),
    )
  );
  .boxitem-icon {
    font-size: 24px;
  }
}
</style>
